import type { RealtimeSubscriptionAdapter } from '../types/subscription-adapter.types';
import { getAckPayload } from '../utils/socket-message.util';
import { chunkTopics } from '../utils/socket-subscription.util';

const MAX_TOPICS_PER_REQUEST = 50;

/** Existing unversioned protocol for topics without a specialized adapter. */
export const standardSubscriptionAdapter: RealtimeSubscriptionAdapter = {
  matchesTopic: () => true,
  isEnabled: () => true,
  requiresAuthorization: false,
  serializeRequests: (type, topics, token) =>
    chunkTopics(topics, MAX_TOPICS_PER_REQUEST).map((chunk) =>
      JSON.stringify({ type, topics: chunk, ...(token ? { token } : {}) })
    ),
  getAcknowledgedOperation: (message) => {
    const { action } = getAckPayload(message.payload);
    return action === 'subscribe' || action === 'unsubscribe'
      ? action
      : undefined;
  },
};
